import { EHoldingTypeNCD } from "../Constants/constant";
export function validatePaymentMode(paymentMode, uploadDeclaration) {
    var _a, _b, _c;
    var isPaymentModeValid = false;
    switch (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.type) {
        case EHoldingTypeNCD.RTGS:
            isPaymentModeValid =
                ((_a = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName) === null || _a === void 0 ? void 0 : _a.value) &&
                    (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.rtgsNo) &&
                    (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.rtgsNo.length) >= 3 &&
                    (uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration.length) > 0
                    ? true
                    : false;
            break;
        case EHoldingTypeNCD.Cheque:
            isPaymentModeValid =
                Boolean((_b = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName) === null || _b === void 0 ? void 0 : _b.value) &&
                    Boolean(paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo) &&
                    Boolean((uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration.length) > 0);
            break;
        case EHoldingTypeNCD.NetBanking:
            isPaymentModeValid = Boolean((_c = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName) === null || _c === void 0 ? void 0 : _c.value);
            break;
    }
    return isPaymentModeValid;
}
